import { render, staticRenderFns } from "./EmployeeGFSlipDetails.vue?vue&type=template&id=230a44bc&scoped=true"
import script from "./EmployeeGFSlipDetails.vue?vue&type=script&lang=js"
export * from "./EmployeeGFSlipDetails.vue?vue&type=script&lang=js"
import style0 from "./EmployeeGFSlipDetails.vue?vue&type=style&index=0&id=230a44bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230a44bc",
  null
  
)

export default component.exports